export type AuthUser = {
  userId: string | null;
  userName: string;
  userEmail: string;
  userMobile: string;
};

export type AuthState = {
  isLogin: boolean;
  // env: "development" | "production" | "staging" | string;
  user: AuthUser | null;
};

const LS_KEY = "cq_auth_state_v1";

function safeJsonParse<T>(raw: string | null): T | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export const AuthStorage = {
  getState(): AuthState {
    const saved = safeJsonParse<AuthState>(localStorage.getItem(LS_KEY));

    // default state
    const base: AuthState = {
      isLogin: false,
      // env: process.env.NODE_ENV || "development",
      user: null,
    };

    // merge (so future fields don't break older saved state)
    return saved ? { ...base, ...saved } : base;
  },

  setState(next: AuthState) {
    localStorage.setItem(LS_KEY, JSON.stringify(next));
  },

  setUser(user: AuthUser) {
    const prev = this.getState();
    const next: AuthState = {
      ...prev,
      isLogin: true,
      user,
    };
    this.setState(next);
  },

  clear() {
    localStorage.removeItem(LS_KEY);
  },

  getUser(): AuthUser | null {
    return this.getState().user;
  },

  getUserName(): string | null {
    return this.getState().user?.userName ?? null;
  },

  getUserEmail(): string | null {
    return this.getState().user?.userEmail ?? null;
  },

  getUserMobile(): string | null {
    return this.getState().user?.userMobile ?? null;
  },

  isLoggedIn(): boolean {
    return this.getState().isLogin && !!this.getState().user;
  },
};
